function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

import React, { useCallback, useState, useEffect, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Trans, useTranslation } from 'react-i18next';
import { AnimatePresence } from 'framer-motion';
import { useDebounce } from 'react-use';
import { Input, Tooltip, TitleComponent } from '@keen.io/ui-core';
import { Icon } from '@keen.io/icons';
import { colors } from '@keen.io/colors';
import { BodyText, FontWeight } from '@keen.io/typography';
import { LimitInput, TooltipMotion, TitleWrapper, TooltipContainer, Container, TooltipWrapper } from './Extraction.styles';
import { ExtractionProperties } from './components';
import { setPropertyNames, setExtractionLimit, getExtractionLimit, resetExtraction, getExtractionPropertyNames } from '../../modules/query';
import { TOOLTIP_MOTION } from '../../constants';
import { DEFAULT_LIMIT, PREVIEW_EVENTS_LIMIT, HIDE_TIME } from './constants';

var Extraction = function Extraction(_ref) {
  var collection = _ref.collection;
  var dispatch = useDispatch();

  var _useTranslation = useTranslation(),
      t = _useTranslation.t;

  var hideLimitHintTrigger = useRef(null);

  var _useState = useState({
    visible: false
  }),
      _useState2 = _slicedToArray(_useState, 2),
      tooltip = _useState2[0],
      setTooltip = _useState2[1];

  var _useState3 = useState(false),
      _useState4 = _slicedToArray(_useState3, 2),
      rangeValidationTooltipVisible = _useState4[0],
      setRangeValidationTooltipVisible = _useState4[1];

  useDebounce(function () {
    return setRangeValidationTooltipVisible(false);
  }, 3000, [rangeValidationTooltipVisible]);
  var extractionLimit = useSelector(getExtractionLimit);
  var properties = useSelector(getExtractionPropertyNames);
  var changeLimitHandler = useCallback(function (eventValue) {
    if (!eventValue) {
      setRangeValidationTooltipVisible(true);
      return dispatch(setExtractionLimit(undefined));
    }

    var value = parseInt(eventValue);

    if (value > PREVIEW_EVENTS_LIMIT) {
      if (hideLimitHintTrigger.current) {
        clearTimeout(hideLimitHintTrigger.current);
      }

      dispatch(setExtractionLimit(PREVIEW_EVENTS_LIMIT));
      setTooltip({
        visible: true
      });
      hideLimitHintTrigger.current = setTimeout(function () {
        return setTooltip({
          visible: false
        });
      }, HIDE_TIME);
    } else if (value <= 0) {
      setRangeValidationTooltipVisible(true);
      dispatch(setExtractionLimit(DEFAULT_LIMIT));
    } else {
      dispatch(setExtractionLimit(value));
    }
  }, []);
  useEffect(function () {
    return function () {
      dispatch(resetExtraction());
    };
  }, []);
  return React.createElement(Container, null, React.createElement(ExtractionProperties, {
    properties: properties ? properties : [],
    collection: collection,
    onSetProperties: function onSetProperties(properties) {
      return dispatch(setPropertyNames(properties));
    }
  }), React.createElement("div", null, React.createElement(TitleWrapper, null, React.createElement(TitleComponent, null, t('extraction.limit_label')), React.createElement(TooltipContainer, {
    onMouseEnter: function onMouseEnter() {
      return setTooltip({
        visible: true
      });
    },
    onMouseLeave: function onMouseLeave() {
      return setTooltip({
        visible: false
      });
    }
  }, React.createElement(Icon, {
    type: "info",
    fill: colors.blue['500']
  }), React.createElement(AnimatePresence, null, tooltip.visible && React.createElement(TooltipMotion, Object.assign({}, TOOLTIP_MOTION, {
    "data-testid": "extraction-limit-hint"
  }), React.createElement(Tooltip, {
    hasArrow: false,
    mode: "dark"
  }, React.createElement(BodyText, {
    variant: "body2",
    color: colors.white[500]
  }, t('extraction.maximum_events_limit'), React.createElement("br", null), React.createElement("br", null), React.createElement(Trans, {
    components: {
      bold: React.createElement(FontWeight, {
        fontWeight: "bold"
      })
    },
    i18nKey: 'extraction.extraction_to_email_limit'
  }))))))), React.createElement(LimitInput, null, React.createElement(Input, {
    type: "number",
    variant: "solid",
    onBlur: function onBlur() {
      return !extractionLimit && dispatch(setExtractionLimit(DEFAULT_LIMIT));
    },
    value: extractionLimit || '',
    placeholder: t('extraction.limit_placeholder'),
    onChange: function onChange(e) {
      return changeLimitHandler(e.target.value);
    }
  }), React.createElement(AnimatePresence, null, rangeValidationTooltipVisible && React.createElement(TooltipWrapper, Object.assign({}, TOOLTIP_MOTION, {
    "data-testid": "validation-tooltip"
  }), React.createElement(Tooltip, {
    hasArrow: true,
    arrowDirection: "top"
  }, React.createElement(BodyText, {
    variant: "body2",
    color: colors.black[100]
  }, t('extraction.range_validation_tooltip'))))))));
};

export default Extraction;